"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
const Popover_1 = __importDefault(require("./Popover"));
const FilterButton = ({ active, btnAriaLabel, btnText, children, dataTestId, popoverDirection, onOpen }) => {
    const buttonContainerRef = (0, react_1.useRef)(null);
    const [showPopover, setShowPopover] = (0, react_1.useState)(false);
    const handleClick = () => {
        if (!showPopover) {
            onOpen();
        }
        setShowPopover(!showPopover);
    };
    return (react_1.default.createElement(styles_1.FilterButtonContainer, { ref: buttonContainerRef },
        react_1.default.createElement(button_1.default, { onClick: handleClick, "aria-label": btnAriaLabel, mode: active ? 'primary' : undefined, "data-testid": dataTestId }, btnText),
        showPopover && (react_1.default.createElement(Popover_1.default, { buttonRef: buttonContainerRef, open: showPopover, onClose: handleClick, direction: popoverDirection, dataTestId: `${dataTestId}-popover` }, children))));
};
FilterButton.propTypes = {
    active: prop_types_1.bool,
    btnText: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.node]).isRequired,
    btnAriaLabel: prop_types_1.string,
    children: prop_types_1.node.isRequired,
    dataTestId: prop_types_1.string,
    popoverDirection: (0, prop_types_1.oneOf)(['right', 'left']),
    onOpen: prop_types_1.func
};
exports.default = FilterButton;
//# sourceMappingURL=FilterButton.js.map